import { axiosInstance as axios, handleAxiosErrors } from '../_utils';
import config from '../store/_config';

export const setGlobalConfig = (value) => {
    return {
        type: 'SET_GLOBAL_CONFIG',
        value: value,
    };
};
export const toggleGlobalConfigLoading = (value) => {
    return {
        type: 'TOGGLE_GLOBAL_CONFIG_LOADING',
        value: value,
    };
};

const decodeBase64 = (str) => {
    try {
        return JSON.parse(window.decodeJsonFromBase64(str));
    } catch (error) {
        console.error('Error decoding Base64:', error);
        return null;
    }
};

const getResellerValue = () => {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const reseller = urlParams.get('reseller');
    if (reseller) {
        // document.getElementById('global-loader').style.display = 'block';
        const decoded = decodeBase64(reseller);
        if (decoded && decoded.ID) {
            return decoded.ID;
        }
    }
    return null;
};


export const requestGlobalConfig = () => {
    return (dispatch) => {
        const resellerID = getResellerValue();

        if (resellerID) {
            const currentUrl = window.location.href;
            const dynamicPathMatch = currentUrl.match(/\/(.*?)\/\?reseller/);
            const dynamicRedirectUrl = dynamicPathMatch
                ? `/${dynamicPathMatch[1]}`
                : '/';
            console.log('dynamicPathMatch',dynamicPathMatch);
            dispatch(toggleGlobalConfigLoading(true));
            if (
                dynamicPathMatch &&
                (dynamicPathMatch[0].includes('electronic-identification') ||
                    dynamicPathMatch[0].includes('visual-identification'))
            ) {
                document.getElementById(
                    'global-logo-loader-pre'
                ).style.display = 'none';
            }
            console.log('Reseller ID found:', resellerID);
            return axiosRequestCreateGuestMember(resellerID)
                .then((response) => {
                    const { data } = response;
                    if (
                        data &&
                        data.data &&
                        data.data.createGuestMember &&
                        data.data.createGuestMember.ID
                    ) {
                        dispatch(toggleGlobalConfigLoading(false));
                        const memberID = data.data.createGuestMember.ID;
                        window.location.href = dynamicRedirectUrl;
                        // document.getElementById('global-loader').style.display = 'none';
                    }
                })
                .catch((error) => {
                    dispatch(toggleGlobalConfigLoading(false));
                    document.getElementById('global-loader').style.display =
                        'none';
                    handleAxiosErrors(error);
                });
        } else {
            console.log('No valid reseller ID found');
            return axiosRequestGlobalConfig()
                .then((response) => {
                    const { data } = response;

                    dispatch(setGlobalConfig(data.data.readGlobalConfig));
                })
                .catch((error) => {
                    handleAxiosErrors(error);
                });
        }
    };
};

export const axiosRequestGlobalConfig = () => {
    let { url, query } = config.globalConfig.read;

    return axios.get(url, {
        withCredentials: true,
        params: {
            query: query,
        },
    });
};

export const axiosRequestCreateGuestMember = (ResellerID) => {
    let { url, query } = config.createGuestMember.create;

    return axios.post(
        url,
        {
            query: query,
            variables: {
                ResellerID: ResellerID,
            },
        },
        {
            withCredentials: true,
        }
    );
};
